import '../contest_result_card/index.css';
import { isSmartPhone } from '../../../utilities/helper';

import React from 'react';
import ContestResultCardMWeb from './index_mWeb';
import ContestResultCardWeb from './index_web';

interface Props {
  onPressCard: any;
  contest: any;
  matchVerifiedStatus: boolean;
  matchTeamScore?: any;
}
const ContestResultCard = ({
  onPressCard,
  contest,
  matchVerifiedStatus = false,
  matchTeamScore = 0
}: Props) => {
  return (
    <>
      {isSmartPhone ? (
        <ContestResultCardMWeb
          onPressCard={onPressCard}
          contest={contest}
          matchVerifiedStatus={matchVerifiedStatus}
          matchTeamScore={matchTeamScore}
        />
      ) : (
        <ContestResultCardWeb
          onPressCard={onPressCard}
          contest={contest}
          matchVerifiedStatus={matchVerifiedStatus}
          matchTeamScore={matchTeamScore}
        />
      )}
    </>
  );
};
export default React.memo(ContestResultCard);
